<!-- Start Content -->
<div class="content-area">
  <div class="title-block">
    <h1>{{title}}</h1>

    <div class="title-block__right">
      <button *ngIf="(enableWorkingHrPopup || isEditMode)" class="btn btn--primary"
        (click)="showDialogCustomeDate(facilityId,timeZone)">
        Working Hours</button>

      <button *ngIf="(!isEditMode && !enableWorkingHrPopup)" [disabled]="true" class="btn btn--primary"
        (click)="showDialogCustomeDate(facilityId,timeZone)">
        Working Hours</button>

      <a class="back-btn" href="javascript:void(0);" (click)="onBack()">
        <i class="back-new"></i> Back
      </a>
    </div>

  </div>

  <div class="form-content-outer">
    <!-- <p-scrollPanel [style]="{width: '100%', height: '100%'}"> -->
    <div class="facility-info">

      <div class="therapist-profile mt-0">
        <div class="therapist-profile__avatar">
          <div class="therapist-profile__img-block">
            <div *ngIf="!isImageSaved" class="therapist-profile__img-block__img">
              <img src="assets/img/building-placeholder.svg" width="60" alt="Avatar">
            </div>

            <div *ngIf="isImageSaved" class="therapist-profile__img-block__img">
              <img [(src)]="cardImageBase64" alt="Avatar">
            </div>
          </div>

          <div class="therapist-profile__change-picture">
            <span>Change Picture</span>
            <input type="file" placeholder="Choose file" (change)="uploadLogoFile($event)">
          </div>
        </div>

        <!-- <div *ngIf="isImageSaved" class="therapist-profile__img-block__img">
          <img [(src)]="cardImageBase64" alt="Avatar">
        </div> -->
      </div>

      <div class="form-outer">
        <form class="form" [formGroup]="form" autocomplete="off">

          <div class="form__group">
            <label class="form__label">Facility Name</label>
            <input #fname type="text" formControlName="facility" class="form__control" pInputText maxlength="100" />
            <span class="invalid-feedback"
              *ngIf="hasError(formFields.facility, 'required') || hasError(formFields.facility, 'whitespace')">{{validationMessages.facility.required}}</span>
          </div>
          <!--<span *ngIf="hasError(formFields.facility, 'validCharacters')">{{validationMessages.facility.validCharacters}}</span>-->

          <div class="form__group">
            <label class="form__label">Description<span class="msg-info"> (Max 2000 Characters)</span></label>
            <p-editor formControlName="bioEditorText" [style]="{height: '200px'}"></p-editor>
            <span class="invalid-feedback"
              *ngIf="hasError(formFields.bioEditorText, 'required') || hasError(formFields.bioEditorText, 'whitespace')">{{validationMessages.bioEditorText.required}}</span>
            <span class="invalid-feedback" *ngIf="hasError(formFields.bioEditorText, 'maxlength')">
              {{validationMessages.bioEditorText.maxlength}}
            </span>
          </div>
          <div class="col">
            <div class="form__group">
              <span class="form__checkbox-outer">
                <p-checkbox name="groupname" [(ngModel)]="remoteAssistant" label="Is Remote Setup Facility"
                  binary="true" [ngModelOptions]="{standalone: true}"
                  (onChange)="onRemoteAssistantSelect(remoteAssistant)" inputId="remoteSetupFacility">
                </p-checkbox>
                <label class="checkbox-text" for="remoteSetupFacility">Is Remote Setup Facility</label>
              </span>
              <!-- <span  class="invalid-feedback" *ngIf="hasError(formFields.room, 'whitespace') || hasError(formFields.room, 'validNumber')">{{validationMessages.zipCode.validNumber}}</span> -->
            </div>
            <div class="form__group">
              <span class="switchBtn" style="margin: 1rem 0 -2rem 2px;">
                <p-inputSwitch class="form__switch" [(ngModel)]="isActive"
                  [ngModelOptions]="{standalone: true}"></p-inputSwitch> {{isActive
                ? 'Active' : 'Inactive'}}
              </span>
            </div>
          </div>

          <div class="col">
            <div class="form__group" *ngIf="!remoteAssistant">
              <label class="form__label">Address Line 1</label>
              <textarea class="form__textarea" formControlName="address" pInputTextarea maxlength="500"></textarea>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.address, 'required') || hasError(formFields.address, 'whitespace')">{{validationMessages.address.required}}</span>
            </div>
            <div class="form__group" *ngIf="!remoteAssistant">
              <label class="form__label">Address Line 2</label>
              <textarea class="form__textarea" formControlName="address2" pInputTextarea maxlength="500"></textarea>
              <!--<span class="invalid-feedback" *ngIf="hasError(formFields.address2, 'required') || hasError(formFields.address2, 'whitespace')">{{validationMessages.address.required}}</span>-->
            </div>

          </div>
          <div class="col" *ngIf="!remoteAssistant">
            <div class="form__group">
              <label class="form__label">City</label>
              <input type="text" formControlName="city" class="form__control" pInputText maxlength="100" />
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.city, 'required') || hasError(formFields.city, 'whitespace')">{{validationMessages.cpPerson.city}}</span>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.city, 'validCharacters')">{{validationMessages.cpPerson.validCharacters}}</span>
            </div>
            <div class="form__group">
              <label class="form__label">State</label>
              <p-select class="form__dropdown select-box" formControlName="state" [(ngModel)]="selectedState"
                [options]="stateModel" placeholder="Select" optionLabel="appStateName" filter="true"></p-select>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.state, 'required') || hasError(formFields.state, 'whitespace')">{{validationMessages.cpPerson.state}}</span>
            </div>
          </div>
          <div class="col" *ngIf="!remoteAssistant">
            <div class="form__group">
              <label class="form__label">Zip Code</label>
              <input type="text" formControlName="zipCode" class="form__control" pInputText maxlength="6" />
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.zipCode, 'required') || hasError(formFields.zipCode, 'whitespace')">{{validationMessages.zipCode.required}}</span>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.zipCode, 'validNumber')">{{validationMessages.zipCode.validNumber}}</span>
            </div>
            <div class="form__group">
              <label class="form__label">Branch</label>
              <p-select class="form__dropdown select-box" formControlName="branchName" [options]="branch"
                [(ngModel)]="selectedBranch" (onChange)="onBranchChange($event)" placeholder="Select"
                optionLabel="label" filter="true">
              </p-select>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.branchName, 'required')">{{validationMessages.branchName.required}}</span>
            </div>
          </div>
          <div class="col" *ngIf="!remoteAssistant">
            <div class="form__group">
              <label class="form__label">Contact Person First Name</label>
              <input type="text" formControlName="cpFName" class="form__control" pInputText maxlength="100" />
              <!--<span class="invalid-feedback" *ngIf="hasError(formFields.cpFName, 'required') || hasError(formFields.cpFName, 'whitespace')">{{validationMessages.cpPerson.fNameRequired}}</span>-->
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.cpFName, 'validCharacters')">{{validationMessages.cpPerson.validCharacters}}</span>
            </div>
            <div class="form__group">
              <label class="form__label">Contact Person Last Name</label>
              <input type="text" formControlName="cpLName" class="form__control" pInputText maxlength="100" />
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.cpLName, 'validCharacters')">{{validationMessages.cpPerson.validCharacters}}</span>
            </div>
          </div>
          <div class="col" *ngIf="!remoteAssistant">
            <div class="form__group">
              <label class="form__label">Contact Person Email</label>
              <input type="text" formControlName="email" class="form__control" pInputText maxlength="100" />
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.email,'email')">{{validationMessages.email.email}}</span>
            </div>
            <div class="form__group">
              <label class="form__label">Contact Person Phone Number</label>
              <p-inputMask mask="999-999-9999" formControlName="cpPhnNumber" class="form__phone" pInputText
                maxlength="15"></p-inputMask>
            </div>

          </div>
          <div class="col multibox">
            <div class="form__group">
              <label class="form__label">Doctor Exclusion</label>

              <p-autoComplete [(ngModel)]="excludedDoctor" class="autocomplete-control"
                [ngModelOptions]="{standalone: true}" [suggestions]="results" (completeMethod)="search($event)"
                [forceSelection]="true" [minLength]="1" placeholder="Doctors" multiple fluid>
              </p-autoComplete>
            </div>

            <div class="form__group">
              <label class="form__label">Therapist Exclusion</label>
              <p-autoComplete [(ngModel)]="excludedTherapist" class="autocomplete-control"
                [ngModelOptions]="{standalone: true}" [suggestions]="resultsTherapists" (completeMethod)="searchTherapist($event)"
                [forceSelection]="true" [minLength]="1" placeholder="Therapists" multiple fluid>
              </p-autoComplete>

            </div>
            <div class="form__group insurance">
              <label class="form__label">Insurance Exclusion</label>
              <p-multiSelect class="form__multiSelect select-box" [options]="insuanceInfo"
                formControlName="insuanceInfo" [filter]="true" dataKey="label" placeholder="Select Insurance Company"
                optionLabel="label" selectedItemsLabel="{0} Insurances Selected"></p-multiSelect>

              <a class="last-box__add-btn" pTooltip="Add Insurance" href="javascript:void(0)" (click)="AddInsurance()">
                <i class="ic plus"></i>
              </a>
            </div>
            <div class="form__group" *ngIf="!remoteAssistant">
              <label class="form__label">Time Zone</label>
              <p-select class="form__dropdown select-box" [options]="timeZoneList" formControlName="timeZone"
                [(ngModel)]="selectedTimeZone" (onChange)="onTimeZoneChange($event.value)" placeholder="Select"
                optionLabel="appStandardTimeZoneName" >
              </p-select>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.timeZone, 'required')">{{validationMessages.timeZone.required}}</span>
            </div>
          </div>
          <div class="col" *ngIf="isViewSelfScheduleAppointments">
            <div class="form__group">
              <label class="form__label">Self Scheduling Permission</label>
              <div style="width: 100%;" class="switchBtn">
                <p-inputSwitch class="form__switch" [(ngModel)]="isAllowSelfScheduleAppointments"
                  [ngModelOptions]="{standalone: true}"></p-inputSwitch>{{isAllowSelfScheduleAppointments ? 'Active' :
                'Inactive'}}
              </div>
            </div>
          </div>

          <div class="set-custom-date-btn">
            <button class="btn btn--primary" type="submit" (click)="onSubmit()">Submit</button>
            <button class="btn btn--secondary" type="button" (click)="onCancel()">Cancel</button>
          </div>


        </form>
      </div>

    </div>
  </div>


  <ng-template #loading style="height: 100%; position: absolute; width: 100%; text-align: center;">
    <div class="loader-block">
      <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff"
        animationDuration=".8s">
      </p-progressSpinner>
    </div>
  </ng-template>

  <div class="loader-block" *ngIf="loadingCustom">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
    </p-progressSpinner>
  </div>
  <!-- </p-scrollPanel> -->

</div>
<!-- End Content -->


<!-- New Popup for working hours-->

<p-dialog [(visible)]="dialogCustomeDate" [modal]="true" styleClass="working-hours-popup">
  <!-- <a href="javascript:void(0)" class="popup-close" (click)="hideDialogCustomeDate()"></a> -->
  <div class="working-hours-popup-outer">
    <h2 *ngIf="displayFacilityName" class="working-hours-popup-outer__title">Working Hours
      <span>({{crmFacilityName}})</span>
    </h2>
    <div class="working-hours-popup-outer__working-hours-form">

      <div class="working-hours-popup-outer__content">
        <!-- Monday Row-->
        <div class="working-hours-popup-outer__content-row" *ngFor="let item of WeekDayList">
          <div class="working-hours-popup-outer__content-column"><strong>{{item.name}}</strong></div>
          <div class="working-hours-popup-outer__content-column">
            <div class="checkbox-dropdown">
              <!-- <p-checkbox name="groupname" value="Monday" [(ngModel)]="selectedValues"></p-checkbox> -->

              <p-select  class="form__dropdown" appendTo="body" panelStyleClass="days-onoff" [options]="Day" placeholder="Select" optionLabel="name"
                [ngModelOptions]="{standalone: true}" [(ngModel)]="item.isOn" (onChange)="changeDayOnOff(item)" styleClass="z-index-9999">
              </p-select>
            </div>

          </div>
          <div class="working-hours-popup-outer__content-column">
            <p-select class="form__dropdown" appendTo="body" panelStyleClass="facility-time" [options]="item.StartTimeSelectionList" optionLabel="name"
                  [(ngModel)]="item.DayWorkingHour.fromTime" id="startTimeDropdown" placeholder="Select" optionValue="name"
                  [filter]="true" [disabled]="item.isOn?.code == 0" (onChange)="changeDayOnOff(item)"  styleClass="z-index-9999"></p-select>
          </div>
          <div class="working-hours-popup-outer__content-column">
            <p-select class="form__dropdown" appendTo="body" panelStyleClass="facility-time" [options]="item.EndTimeSelectionList" optionLabel="name"
                  [(ngModel)]="item.DayWorkingHour.toTime" id="startTimeDropdown" placeholder="Select" optionValue="name"
                  [filter]="true" [disabled]="item.isOn?.code == 0" (onChange)="changeDayOnOff(item)"  styleClass="z-index-9999"></p-select>
          </div>
        </div>

      </div>

      <div class="working-hours-popup-outer__button">
        <button class="btn btn--primary" type="submit" (click)="OnWorkingHoursSubmit()">Save</button>
        <button class="btn btn--secondary" type="button" (click)="hideDialogCustomeDate()">Cancel</button>
      </div>
    </div>
  </div>
</p-dialog>
